import type { ReactNode } from "react";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";

interface Props {
  label: ReactNode;
  /** The id of the control, so the label focuses it. */
  htmlFor?: string;
  hint?: ReactNode;
  children: ReactNode;
  className?: string;
}

/** A label above its control, and an optional line under it. */
export function Field({ label, htmlFor, hint, children, className }: Props) {
  return (
    <div data-slot="field" className={cn("flex min-w-0 flex-col gap-1.5", className)}>
      <Label htmlFor={htmlFor}>{label}</Label>
      {children}
      {hint && <p className="text-label text-muted-foreground">{hint}</p>}
    </div>
  );
}
